export const publicPath = "kjop-forsikring";

export const MINIMUM_DISCOUNT = 12;

export const enum PaymentPeriod {
  YEARLY = 1,
  HALF_YEARLY = 2,
  QUARTERLY = 4,
  MONTHLY = 12,
  SHORT_TERM = 99,
}

export enum InsuranceType {
  ACCIDENT = "ulykke",
  ADVICE = "raadgivning",
  AKA_CHILD = "aka-barn",
  AKA_FAMILY_ACCIDENT = "aka-familieulykke",
  AKA_STUDENT = "aka-student",
  AKA_HEALTH = "aka-helse",
  AKA_HOUSE_CONTENTS = "aka-innbo",
  AKA_TRAVEL = "aka-reise",
  BOAT = "baat",
  ANIMAL = "hund-og-katt",
  CABIN = "hytte",
  CABIN_CONTENTS = "hytteinnbo",
  CAR = "car",
  CARAVAN = "caravan",
  CHILD = "barn",
  ELECTRIC_SCOOTER = "elsparkesykkel",
  HEALTH = "helse",
  HOUSE = "hus",
  HOUSE_CONTENTS = "innbo",
  HUSEIERNE_HOUSE_CONTENTS = "huseierne-innbo",
  MOPED = "moped",
  MOTORCYCLE = "motorsykkel",
  PREGNANT_AND_NEWBORN = "gravid-og-spedbarn",
  RENTAL = "utleie",
  SOP_SICKNESS_LEAVE = "sop-sykeavbrudd",
  TRACTOR = "traktor",
  TRAILER = "trailer",
  TRAVEL = "reise",
  VALUABLE = "verdisak",
  VETERAN_AUTO = "veteranbil",
}

export enum MainPath {
  ACCEPT = "aksept",
  CHECK_PRICE = "sjekk-pris",
  CHECKOUT = "utsjekk",
  DOWNTIME = "nedetid",
  UPSELL = "flere-forsikringer",
  OFFER = "tilbud",
  OFFER_ACCEPT = "tilbud-fra-raadgiver",
  OFFER_ACCEPT_PRINT_FRIENDLY = "utskriftsvennlig-tilbud-fra-raadgiver",
  RECEIPT = "kvittering",
  UNEXPECTED = "uforventet",
}

export enum Uri {
  ADVICE_DOCUMENT = "adviceDocument",
  PRODUCTS = "products",
}

export const enum TileNames {
  LOGIN = "login",
  OFFER = "tilbud",
  CHECKOUT = "kjop",
  DEFAULT = "default",
}

export const convertToURI = (tileId: string): string => {
  return tileId.replace(" ", "_");
};

export enum IllustrationName {
  OFFICE_BUILDING = "office-building-1",
  SAFETY_SECURITY = "safety-security",
  WOMAN_SUCCESS = "woman-success",
  ESTABLISHMENT_FAMILY = "establishment-family",
  CUSTOMER_SERVICE_WOMAN = "customer-service-woman",
  COUPLE_SPORTSCAR = "couple-sportscar",
  SOMETHING_WENT_WRONG = "something-went-wrong",
  SIMPLICITY = "simplicity",
}

export enum IconName {
  OFFICE_BUILDING = "office-building-1",
}

export enum ErrorPrefix {
  BREAKING = "{{{BREAKING}}}",
}

export enum Environment {
  PRODUCTION = "production",
  CLIENT_TS = "client-ts",
  CLIENT_T = "client-t",
  DEVELOPMENT = "development",
}

export enum WebDiscountValue {
  DEFAULT = 10,
  SPECIAL = 15,
  SSX_815_SUMMER_DISCOUNT = 20,
}

export enum WebDiscountValueHuseierne {
  HOUSE_AND_CABIN = 20,
  OTHER_RISK_PRODUCT = 18,
}
